import { Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'

import CoursesCategoryPage from './CoursesCategory/CoursesCategoryPage'
import CoursesDynamicsPage from './CoursesDynamics/CoursesDynamicsPage'
import CoursesListPage from './Courses/CoursesPage'
import CoursesObjectivesPage from './CoursesObjectives/CoursesObjectivesPage'
import CoursesOnlinePage from './CoursesOnline/CoursesOnlinePage'
import KnowledgeAreaPage from './KnowledgeArea/KnowledgeAreaPage'

const CoursesPage = () => {
  return (
    <>
      <Heading as="h1" size="lg" mb="10" textTransform="uppercase">
        Gerenciamento de Cursos
      </Heading>
      <Tabs isLazy variant="enclosed" colorScheme="magenta">
        <TabList>
          <Tab _selected={{ color: 'black', bg: 'gray.50' }}>Cursos presenciais/ao vivo</Tab>
          <Tab _selected={{ color: 'black', bg: 'gray.50' }}>Cursos online/vídeo-aula</Tab>
          <Tab _selected={{ color: 'black', bg: 'gray.50' }}>Áreas de Conhecimento</Tab>
          <Tab _selected={{ color: 'black', bg: 'gray.50' }}>Categorias de Cursos</Tab>
          <Tab _selected={{ color: 'black', bg: 'gray.50' }}>Dinâmica de Ensino</Tab>
          <Tab _selected={{ color: 'black', bg: 'gray.50' }}>Objetivo do Curso</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <CoursesListPage />
          </TabPanel>
          <TabPanel>
            <CoursesOnlinePage />
          </TabPanel>
          <TabPanel>
            <KnowledgeAreaPage />
          </TabPanel>
          <TabPanel>
            <CoursesCategoryPage />
          </TabPanel>
          <TabPanel>
            <CoursesDynamicsPage />
          </TabPanel>
          <TabPanel>
            <CoursesObjectivesPage />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}

export default CoursesPage
